import { api } from "./api";

export const topicFocus = api.injectEndpoints({
    endpoints: (builder) => ({
        getTopicFocus: builder.query<any, { page: number, selectedOption?: number, timeFilter?: number, subject?: string, topic?: string }>({
            query: (arg) => {
                const { page, selectedOption, timeFilter, subject, topic } = arg;
                return {
                    url: "/TopicFocus/TopicFocus",
                    params: { page: page, filter: selectedOption, timeFilter: timeFilter, subject: subject, topic: topic },
                    method: "GET"
                }
            },
            providesTags: ["TopicFocus"]
        }),
        addTopicFocusToCoursework: builder.mutation<any, { segmentId: number, page: number }>({
            query: (body) => ({
                url: "/TopicFocus/AddTopicFocusToCoursework",
                method: "PUT",
                body: body
            }),
            invalidatesTags: ["Coursework", "OverallProgress"]
        }),
        removeTopicFocusFromCoursework: builder.mutation<any, { productOfferingSegmentId: number, page: number }>({
            query: (body) => ({
                url: "/TopicFocus/RemoveTopicFocusFromCoursework",
                method: "PUT",
                body: body
            }),
            invalidatesTags: ["Coursework", "OverallProgress"],
        }),

    })
})

export const {
    useGetTopicFocusQuery,
    useLazyGetTopicFocusQuery,
    useAddTopicFocusToCourseworkMutation,
    useRemoveTopicFocusFromCourseworkMutation,
} = topicFocus;
